module.exports = __webpack_public_path__ + "img/slogan_en.c2a745ef.png";